<template>
  <div ref="listOfVns" :class="classHowManyVns">
    <div class="hexagon-grid-container">
      <vnsHexagon
          v-for="(vns, index) in vnsListComputed"
          :key="index"
          :title="vns.title ? vns.title : ''"
          :text-primary="vns.textPrimary ? vns.textPrimary : ''"
          :text-secondary="vns.textSecondary ? vns.textSecondary : ''"
          :text-sub-title="vns.textSubTitle ? vns.textSubTitle : ''"
          :hexagon-class="vns.hexagonClass ? 'hexagon-' + vns.hexagonClass : ''"
          :hexagon-custom="vns.hexagonCustom ? vns.hexagonCustom : []"
          :vns-icons="vns.icons ? vns.icons : {}"
          @click-left="$emit('click-left', vns)"
          @click-center="$emit('click-center', vns)"
          @click-right="$emit('click-right', vns)"
      />
    </div>
  </div>
</template>

<script>
import vnsHexagon from "@/pages/vns/components/vnsHexagon";

export default {
  name: "vnsHexagonList",
  components: {
    vnsHexagon
  },
  props: {
    vnsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    vnsListComputed() {
      return this.vnsList;
    },
    classHowManyVns() {
      switch (this.vnsPerLine) {
        case 2:
          return 'two-vns-per-line'
          break;
        case 3:
          return 'three-vns-per-line'
          break;
        case 4:
          return 'four-vns-per-line'
          break;
        case 5:
          return 'five-vns-per-line'
          break;
        case 6:
          return 'six-vns-per-line'
          break;
        case 7:
          return 'seven-vns-per-line'
          break;
        case 8:
          return 'eight-vns-per-line'
          break;
        case 9:
          return 'nine-vns-per-line'
          break;
        case 10:
          return 'ten-vns-per-line'
          break;
        case 11:
          return 'eleven-vns-per-line'
          break;
        case 12:
          return 'twelve-vns-per-line'
          break;
        case 13:
          return 'thirteen-vns-per-line'
          break;
        case 14:
          return 'fourteen-vns-per-line'
          break;
        case 15:
          return 'fithteen-vns-per-line'
          break;
        case 16:
          return 'sixteen-vns-per-line'
          break;
        case 17:
          return 'seventeen-vns-per-line'
          break;
        case 18:
          return 'eighteen-vns-per-line'
          break;
        case 19:
          return 'nineteen-vns-per-line'
          break;
        case 20:
          return 'twenty-vns-per-line'
          break;
        default:
          return 'fithteen-vns-per-line'
          break;
      }
    }
  },
  data() {
    return {
      parentWidth: null,
      vnsPerLine: 2,
      listVNS: []
    }
  },
  methods: {
    getAvailableSize() {
      const width = this.$refs.listOfVns.clientWidth
      switch (true) {
        case (width >= 2880):
          this.vnsPerLine = 20
          break;
        case (width < 2880 && width >= 2736):
          this.vnsPerLine = 19
          break;
        case (width < 2736 && width >= 2592):
          this.vnsPerLine = 18
          break;
        case (width < 2592 && width >= 2448):
          this.vnsPerLine = 17
          break;
        case (width < 2448 && width >= 2304):
          this.vnsPerLine = 16
          break;  
        case (width < 2304 && width >= 2160):
          this.vnsPerLine = 15
          break;
        case (width < 2160 && width >= 2016):
          this.vnsPerLine = 14
          break;
        case (width < 2016 && width >= 1872):
          this.vnsPerLine = 13
          break;
        case (width < 1872 && width >= 1728):
          this.vnsPerLine = 12
          break;
        case (width < 1728 && width >= 1584):
          this.vnsPerLine = 11
          break;
        case (width < 1584 && width >= 1440):
          this.vnsPerLine = 10
          break;
        case (width < 1440 && width >= 1296):
          this.vnsPerLine = 9
          break;
        case (width < 1296 && width >= 1152):
          this.vnsPerLine = 8
          break;
        case (width < 1152 && width >= 1008):
          this.vnsPerLine = 7
          break;
        case (width < 1008 && width >= 864):
          this.vnsPerLine = 6
          break;
        case (width < 864 && width >= 720):
          this.vnsPerLine = 5
          break;
        case (width < 720 && width >= 576):
          this.vnsPerLine = 4
          break;
        case (width < 576 && width >= 432):
          this.vnsPerLine = 3
          break;
        case (width < 431):
          this.vnsPerLine = 2
          break;
          this.$forceUpdate()
      }
    }
  },
  mounted() {
    // window.addEventListener("resize", this.getAvailableSize)
    this.timer = setInterval(() => {
      this.getAvailableSize()
    }, 1000)
  },
  updated() {
    this.getAvailableSize()
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.getAvailableSize)
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
/* XV SCSS Variables */
$xv-secondary-light-gray: #c9c9c9;
$xv-secondary-dark-gray: #9fa0a2;
$primary: #4e73df;
$secondary: #858796;
$success: #1cc88a;
$info: #36b9cc;
$warning: #f6c23e;
$danger: #e74a3b;
$light: #f8f9fc;
$dark: #5a5c69;

/*$primary: #bbdefb;
$success: #a5d6a7;
$info: #90caf9;
$warning: #fff59d;
$danger: #ef9a9a;*/

/* Outer Hexagon */
.hexagon-grid-container {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 50px;
}

.twenty-vns-per-line {
  .hexagon-grid-container {
    width: 2880px;
  }

  .hexagon:nth-child(39n+21) {
    margin-left: 74px;
  }
}

.nineteen-vns-per-line {
  .hexagon-grid-container {
    width: 2736px;
  }

  .hexagon:nth-child(37n+20) {
    margin-left: 74px;
  }
}

.eighteen-vns-per-line {
  .hexagon-grid-container {
    width: 2592px;
  }

  .hexagon:nth-child(35n+19) {
    margin-left: 74px;
  }
}

.seventeen-vns-per-line {
  .hexagon-grid-container {
    width: 2448;
  }

  .hexagon:nth-child(33n+18) {
    margin-left: 74px;
  }
}

.sixteen-vns-per-line {
  .hexagon-grid-container {
    width: 2304;
  }

  .hexagon:nth-child(31n+17) {
    margin-left: 74px;
  }
}

/* Media queries */
.fithteen-vns-per-line {
  .hexagon-grid-container {
    width: 2160px;
  }

  .hexagon:nth-child(29n+16) {
    margin-left: 74px;
  }
}

.fourteen-vns-per-line {
  .hexagon-grid-container {
    width: 2016px;
  }

  .hexagon:nth-child(27n+15) {
    margin-left: 74px;
  }
}

.thirteen-vns-per-line {
  .hexagon-grid-container {
    width: 1872px;
  }

  .hexagon:nth-child(25n+14) {
    margin-left: 74px;
  }
}

.twelve-vns-per-line {
  .hexagon-grid-container {
    width: 1728px;
  }

  .hexagon:nth-child(23n+13) {
    margin-left: 74px;
  }
}

.eleven-vns-per-line {
  .hexagon-grid-container {
    width: 1584px;
  }

  .hexagon:nth-child(21n+12) {
    margin-left: 74px;
  }
}

.ten-vns-per-line {
  .hexagon-grid-container {
    width: 1440px;
  }

  .hexagon:nth-child(19n+11) {
    margin-left: 74px;
  }
}

.nine-vns-per-line {
  .hexagon-grid-container {
    width: 1296px;
  }

  .hexagon:nth-child(17n+10) {
    margin-left: 74px;
  }
}

.eight-vns-per-line {
  .hexagon-grid-container {
    width: 1152px;
  }

  .hexagon:nth-child(15n+9) {
    margin-left: 74px;
  }
}

.seven-vns-per-line {
  .hexagon-grid-container {
    width: 1008px;
  }

  .hexagon:nth-child(13n+8) {
    margin-left: 74px;
  }
}

.six-vns-per-line {
  .hexagon-grid-container {
    width: 864px;
  }

  .hexagon:nth-child(11n+7) {
    margin-left: 74px;
  }
}

.five-vns-per-line {
  .hexagon-grid-container {
    width: 720px;
  }

  .hexagon:nth-child(9n+6) {
    margin-left: 74px;
  }
}

.four-vns-per-line {
  .hexagon-grid-container {
    width: 576px;
  }

  .hexagon:nth-child(7n+5) {
    margin-left: 74px;
  }
}

.three-vns-per-line {
  .hexagon-grid-container {
    width: 432px;
  }

  .hexagon:nth-child(5n+4) {
    margin-left: 74px;
  }
}

.two-vns-per-line {
  .hexagon-grid-container {
    width: 320px;
  }

  .hexagon:nth-child(3n+3) {
    margin-left: 74px;
  }
}

/* Hexagon Color Coding */
.hexagon-success {
  background-color: $success;

  &:before {
    border-bottom: 40.41px solid $success;
  }

  &:after {
    border-top: 40.41px solid $success;
  }
}

.hexagon-warning {
  background-color: $warning;

  &:before {
    border-bottom: 40.41px solid $warning;
  }

  &:after {
    border-top: 40.41px solid $warning;
  }
}

.hexagon-danger {
  background-color: $danger;

  &:before {
    border-bottom: 40.41px solid $danger;
  }

  &:after {
    border-top: 40.41px solid $danger;
  }
}

.hexagon-primary {
  background-color: $primary;

  &:before {
    border-bottom: 40.41px solid $primary;
  }

  &:after {
    border-top: 40.41px solid $primary;
  }
}

.hexagon-secondary {
  background-color: $secondary;

  &:before {
    border-bottom: 40.41px solid $secondary;
  }

  &:after {
    border-top: 40.41px solid $secondary;
  }
}

.hexagon-info {
  background-color: $info;

  &:before {
    border-bottom: 40.41px solid $info;
  }

  &:after {
    border-top: 40.41px solid $info;
  }
}

.hexagon-danger,
.hexagon-primary,
.hexagon-success,
.hexagon-warning,
.hexagon-danger,
.hexagon-secondary {
  color: white;
}

</style>
